<template>
  <div class="aut">
    <!-- 拍卖会流程 -->
    <div class="aut-auto wrap">
      <h1>最近拍卖会</h1>
      <!-- 四个图片列表 -->
      <div class="aut-auto-images" v-if="listValue?.length > 0">
        <div v-for="item in listValue" :key="item.id">
          <div class="aut-auto-images-item">
            <div class="imageUrl">
              <img :src="item.carPhoto ? item.carPhoto : defaultImg" alt="" />
            </div>
            <!-- 每一个item项 -->
            <div class="aut-auto-images-item-content">
              <span class="label">{{ item.name }}</span>
            </div>
            <p class="label-time">开拍时间:{{ item.startTime }}</p>
            <p class="label2">
              {{ handleType(item.auctionType) }}拍卖会&nbsp;{{ item.carNum }} 台
            </p>
            <div class="button" @click="handleToRouter(item)">
              <p class="look-view">立即查看</p>
            </div>
          </div>
        </div>
      </div>
      <div v-else><el-empty :image-size="200"></el-empty></div>
    </div>
  </div>
</template>

<script>
import { defaultImg } from "@/data";
import { getFindSysConfigAuctions } from "@/api/Auction/index.js";
export default {
  data() {
    return {
      //图片前缀
      //拍卖会列表
      listValue: [],
      pageInfo: {
        currentPage: 1,
        pageSize: 4,
      },
      defaultImg,
    };
  },
  mounted() {
    this.handleInquireAuction();
  },
  methods: {
    async handleInquireAuction() {
      let res = await getFindSysConfigAuctions({
        ...this.pageInfo,
      });
      if (res.success) {
        this.listValue = res.pageInfo.list;
      }
    },
    handleType(type) {
      switch (type) {
        case 1:
          return "普通";
        case 2:
          return "一口价";
        case 3:
          return "期车";
        case 4:
          return "专场";
        default:
          break;
      }
    },
    //type 1 普通 2一口价 3期车 4专场
    handleToRouter(i) {
      const id = i.id;
      const type = i.auctionType;
      const endTime = i.endTime;
      const startTime = i.startTime;
      localStorage.setItem("auctionEndTime", endTime); // 结束时间
      localStorage.setItem("startTime", startTime); // 开始时间
      this.$router.push(`/ScheduledVehicle?type=${type}&id=${id}`);
      this.$store.commit("SET_CAR_AUCTION_ID", id);
    },
  },
};
</script>

<style lang="less" scoped>
.aut {
  width: 100%;
  background-color: #eef1f6;
  height: 530px;

  .aut-auto {
    padding: 20px 0;

    h1 {
      text-align: center;
      padding: 20px 20px 40px 20px;
      font-size: 24px;
    }

    .aut-auto-images {
      display: grid;
      // 一行显示4个
      grid-template-columns: repeat(4, 1fr);
      // justify-content: space-around;

      .imageUrl {
        position: relative;

        width: 290px;
        height: 215px;

        img {
          width: 100%;
          height: 100%;
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
        }
      }

      .imageUrl::before {
        content: "";
        position: absolute;
        /* 定位伪元素或子元素相对于.imageUrl容器 */
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(
          to bottom,
          rgba(255, 255, 255, 0) 80%,
          #ffffff 100%
        );
        /* 设置渐变背景 */
      }

      .aut-auto-images-item {
        width: 290px;
        height: 370px;
        text-align: center;
        line-height: 40px;
        background-color: #fff;
        border-radius: 10px;
        cursor: pointer;
        .aut-auto-images-item-content {
          display: flex;
          justify-content: center;
          width: 100%;
          .label {
            width: 200px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            color: #070707;
            font-weight: bold;
            font-size: 16px;
            .label-time {
              color: #070707;
              font-size: 16px;
              display: block;
            }
          }
        }

        .label2 {
          color: #999999;
          line-height: 20px;
          margin-bottom: 10px;
          font-size: 16px;
        }

        .button {
          text-align: center;
          border: 1px solid rgb(230, 150, 111);
          border-radius: 50px;
          width: 101px;
          height: 31px;
          margin: 5px auto;
          display: flex;
          justify-content: center;
          flex-direction: column;

          .look-view {
            color: rgb(230, 150, 111);
            font-size: 16px;
          }
        }
      }

      .aut-auto-images-item:hover {
        margin-top: -10px;
        transition-duration: 300ms;
      }
    }
  }
}
</style>